import { Icon } from './Icon';
import type { ReactNode } from 'react';

export function Notice({ children, kind = 'info' }: { children: ReactNode; kind?: 'info' | 'warning' | 'success' | 'error' }) {
  const icon = kind === 'success' ? 'check_circle' : kind === 'warning' ? 'warning' : kind === 'error' ? 'error' : 'info';
  return <div className={`notice notice-${kind}`} role={kind === 'error' ? 'alert' : 'status'}><Icon name={icon} /> <span>{children}</span></div>;
}
